<template>
  <div v-show="!loading" class="dsf_teas_schedule-list">
    <van-empty v-if="!Object.keys(list).length" description="暂无数据" />
    <template v-else>
      <template v-for="(group, day) in list">
        <div :key="day" class="dsf_teas_schedule-list-group">
          <div class="dsf_teas_schedule-list-group-day">
            {{ day | groupFormat }}
          </div>
          <template v-for="(item, index) in group">
            <DsfMobileTeasCell
              cellShape="none"
              :border="true"
              :key="'scheduleitem' + index"
            >
              <div @click="onClick(item, day)">
                <slot name="titleLeft">
                  <div class="scheduleitem-titlecontent">
                    <div class="titlecontent-text">{{ item.courseTime }}</div>
                    <div
                      class="titlecontent-type"
                      v-if="item.teachingMode && item.teachingMode != ''"
                    >
                      {{ item.teachingMode }}
                    </div>
                  </div>
                </slot>
                <DsfMobileTeasCellItem
                  :value="item.courseName || '暂无'"
                  icon="icon-icon-kc"
                >
                </DsfMobileTeasCellItem>
                <DsfMobileTeasCellItem
                  :value="item.teacher || '暂无'"
                  icon="icon-icon-teacher"
                >
                </DsfMobileTeasCellItem>
                <DsfMobileTeasCellItem
                  :value="item.classroom || '暂无'"
                  icon="icon-location-hollow"
                >
                </DsfMobileTeasCellItem>
                <div v-if="isStudent">
                  <div
                    class="schedule-list-item-filediv van-ellipsis"
                    v-for="(tempItem, tempIndex) in item.accessory"
                    :key="'fileitem' + tempIndex"
                    @click.stop="clickFileItem(tempItem)"
                  >
                    <i class="iconfont icon-icon_article"></i>
                    <span>{{ tempItem.name }}</span>
                  </div>
                </div>
              </div>
            </DsfMobileTeasCell>
          </template>
        </div>
      </template>
    </template>
    <van-overlay
      :show="!!active"
      z-index="1000"
      class-name="dsf_teas_schedule-mask"
      @click="active = null"
    >
      <div v-if="!!active" class="dsf_teas_schedule-detail" @click.stop>
        <div class="dsf_teas_schedule-detail-day">
          {{ active.day | groupFormat }}
        </div>
        <div class="dsf_teas_schedule-detail-row van-hairline--bottom">
          <i class="iconfont icon-shijian"></i>
          <span>{{ active.courseTime | emptyFilter("未知") }}</span>
        </div>
        <div class="dsf_teas_schedule-detail-row van-hairline--bottom">
          <i class="iconfont icon-iconxuexinor"></i>
          <span>{{ active.courseName | emptyFilter("未知") }}</span>
        </div>
        <div
          class="dsf_teas_schedule-detail-row van-hairline--bottom"
          @click="dialogRowClick"
        >
          <i class="iconfont icon-wodeweixuanzhong1"></i>
          <span>{{ active.teacher | emptyFilter("未知") }}</span>
        </div>
        <div class="dsf_teas_schedule-detail-row">
          <i class="iconfont icon-location-hollow"></i>
          <span>{{ active.classroom | emptyFilter("未知") }}</span>
        </div>
      </div>
    </van-overlay>
    <van-dialog
      v-model="showNoticeDialog"
      title="备注"
      :message="noticeInfo"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
    </van-dialog>
  </div>
</template>

<script>
// 一天的毫秒数
const oneDay = 86400000;

const testData = {
  "2021-01-24": [
    {
      courseName: "政企专线自配应知应会",
      className: "培训班",
      courseTime: "09:00 - 11:30",
      teacher: "张三",
      classroom: "101教室",
      teachingMode: "现场教学",
    },
    {
      courseName: "政企专线自配应知应会",
      className: "培训班",
      courseTime: "09:00 - 11:30",
      teacher: "张三",
      classroom: "101教室",
      teachingMode: "专题辅导",
    },
    {
      courseName: "政企专线自配应知应会",
      className: "培训班",
      courseTime: "09:00 - 11:30",
      teacher: "张三",
      classroom: "101教室",
      teachingMode: "案例教学",
    },
  ],
  "2021-01-02": [
    {
      courseName: "政企专线自配应知应会",
      className: "培训班",
      courseTime: "09:00 - 11:30",
      teacher: "张三",
      classroom: "101教室",
      teachingMode: null,
    },
    {
      courseName: "政企专线自配应知应会",
      className: "培训班",
      courseTime: "09:00 - 11:30",
      teacher: "张三",
      classroom: "101教室",
      teachingMode: "",
    },
  ],
};

export default dsf.component({
  name: "DsfMobileTeasScheduleList",
  mixins: [$mixins.control],
  ctrlCaption: "日程列表",
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
    // 二次开发传入的方法。
    itemClick: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      list: {},
      active: null,
      noticeInfo: "",
      showNoticeDialog: false,
      isStudent: false,
    };
  },
  watch: {
    url() {
      this.postData();
    },
  },
  filters: {
    groupFormat(v) {
      let date = dsf.date.parse(v);
      let today = dsf.date.toDay();
      let src = dsf.date.format(date, "mm-dd D");
      let diff = date - today;
      if (diff < oneDay && diff >= 0) {
        return src + " (今天)";
      }
      if (diff < oneDay * 2 && diff >= 0) {
        return src + " (明天)";
      }
      if (diff >= -oneDay && diff < 0) {
        return src + " (昨天)";
      }
      return src;
    },
  },
  created() {
    let tempString = dsf.getCookie("stuId") || "";
    if (tempString.length > 0) {
      this.isStudent = true;
    }
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.postData();
    }
  },
  methods: {
    dialogRowClick() {
      this.$emit("dialogRowClick", this.active);
    },
    reloadData() {
      this.postData();
    },
    postData() {
      if (this.isDesign) return;
      if (!this.url || this.url == "") {
        this.list = {};
        return;
      }
      this.loading = true;
      const loading = dsf.layer.loading();
      this.$http
        .get(this.url)
        .done(({ success, data, message }) => {
          if (success) {
            this.list = data;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          console.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .finally(() => {
          this.loading = false;
          dsf.layer.closeLoading(loading);
        });
    },
    onClick(item, day) {
      console.log(111);
      if (this.isDesign) return;
      if (this.itemClick) {
        let res = this.itemClick(item, day);
        if (res === false) return;
        if (res.then) {
          res.then((r) => {
            if (r !== false) {
              this.openPage(item, day);
            }
          });
          return;
        }
      }
      this.openPage(item, day);
    },
    openPage(item, day) {
      this.active = { ...item, day };
    },
    clickRemarkIcon(remarkString) {
      this.noticeInfo = remarkString;
      this.showNoticeDialog = true;
    },
    clickFileItem(item) {
      let tempUrlString = "/mobile/teas/teasmessageapp/mobile-scanBufferPage";
      let textString = item.name || "";
      let idString = item.id || "";
      let fileName = item.originalFileName || "";
      let urlString = item.relativePath || "";
      tempUrlString =
        tempUrlString +
        "?text=" +
        textString +
        "&id=" +
        idString +
        "&url=" +
        urlString +
        "&filename=" +
        fileName;
      this.$router.push({
        path: tempUrlString,
      });
    },
  },
});
</script>